import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import LoadingPlaceholder from 'components/new_ui/WaitLayers/LoadingPlaceholder';

import routes from 'app/routes';
import Modal from 'components/new_ui/Modal/Modal';
import { useContext } from 'components/Affiliates/Prospects/Context';

import useProspect from 'components/Common/Affiliates/Hooks/useProspect';
import Form from '../Form';

export default function Index() {
  const { dispatch, actions } = useContext();
  const navigate = useNavigate();

  const { prospectId } = useParams();

  const prospect = useProspect(prospectId);

  const onSave = (values, { setSubmitting, setErrors }) => {
    actions.update(dispatch, prospectId, values, () => {
      setSubmitting(false);
      navigate(
        routes.affiliates.prospects.index,
      );
    }, (errors) => {
      const newErrors = {};
      errors.forEach((item) => {
        newErrors[item.source.pointer.replace('/data/attributes/', '')] = item.detail;
      });
      setErrors(newErrors);
      setSubmitting(false);
    });
  };

  return (
    <Modal show>
      {prospect === null
        ? <LoadingPlaceholder text="Loading..." className="my-4" />
        : (
          <Form
            onSave={onSave}
            initialValues={{
              company: prospect.attributes.company,
              website: prospect.attributes.website,
              firstName: prospect.attributes.first_name,
              lastName: prospect.attributes.last_name,
              email: prospect.attributes.email,
              phone: prospect.attributes.phone,
              jobTitle: prospect.attributes.jobtitle,
            }}
          />
        ) }
    </Modal>
  );
}
